import React, { FC } from 'react';
import { Box } from '@mui/material';

export const Spinner: FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '80vh',
                '--bike-color': (theme) => theme.palette.text.primary,
                '--bike-bg': (theme) => theme.palette.background.default,
                scale: 0.35,
            }}
        >
            <div className="loader">
                <div className="bike">
                    <div className="wheel back"></div>
                    <div className="wheel front"></div>

                    <div className="frame">
                        {/*<div className="top-tube"></div>*/}
                        <div className="down-tube"></div>
                        <div className="seat-tube"></div>
                        <div className="chain-stay"></div>
                        <div className="seat-stay"></div>
                        <div className="fork"></div>
                    </div>

                    <div className="handlebar"></div>
                    <div className="seat"></div>
                </div>
            </div>
        </Box>
    );
};
